var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVintage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#FDE0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_648_50997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 11.8654C8 10.7453 8 10.1852 8.21799 9.75738C8.40973 9.38106 8.71569 9.0751 9.09202 8.88335C9.51984 8.66536 10.0799 8.66536 11.2 8.66536H16.8C17.9201 8.66536 18.4802 8.66536 18.908 8.88335C19.2843 9.0751 19.5903 9.38106 19.782 9.75738C20 10.1852 20 10.7453 20 11.8654V17.4654C20 18.5855 20 19.1455 19.782 19.5733C19.5903 19.9497 19.2843 20.2556 18.908 20.4474C18.4802 20.6654 17.9201 20.6654 16.8 20.6654H11.2C10.0799 20.6654 9.51984 20.6654 9.09202 20.4474C8.71569 20.2556 8.40973 19.9497 8.21799 19.5733C8 19.1455 8 18.5855 8 17.4654V11.8654Z",
    fill: "#FFA6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12.6654H8M16.6667 7.33203V9.9987M11.3333 7.33203V9.9987M11.2 20.6654H16.8C17.9201 20.6654 18.4802 20.6654 18.908 20.4474C19.2843 20.2556 19.5903 19.9497 19.782 19.5733C20 19.1455 20 18.5855 20 17.4654V11.8654C20 10.7453 20 10.1852 19.782 9.75738C19.5903 9.38106 19.2843 9.0751 18.908 8.88335C18.4802 8.66536 17.9201 8.66536 16.8 8.66536H11.2C10.0799 8.66536 9.51984 8.66536 9.09202 8.88335C8.71569 9.0751 8.40973 9.38106 8.21799 9.75738C8 10.1852 8 10.7453 8 11.8654V17.4654C8 18.5855 8 19.1455 8.21799 19.5733C8.40973 19.9497 8.71569 20.2556 9.09202 20.4474C9.51984 20.6654 10.0799 20.6654 11.2 20.6654Z",
    stroke: "url(#paint0_linear_648_50997)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_648_50997",
    x: 5,
    y: 5,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.0392157 0 0 0 0 0.109804 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_648_50997"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_648_50997",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_648_50997",
    x1: 8,
    y1: 7.33203,
    x2: 20.2056,
    y2: 7.52301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVintage);
export default __webpack_public_path__ + "static/media/Vintage.b7a3c33c4cc74baf8e5b37f76593bbeb.svg";
export { ForwardRef as ReactComponent };